import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { get } from 'lodash';
import LightBox from '@bd/bdui-lightbox';

import ContactModal from '../../components/ContactModal';


function HomeAgent({ agent, home, plan }) {
  const communityBody = get(home, 'cta_body') || 'Yes! I want more information on my dream home.';
  return (
    <div className="contact-plan-section">
      <div className="container">
        <div className="row">
          <div className="col-12 col-lg-6 contact-info">
            <div className="row">
              <div className="col-12 col-lg-4">
                <img src={get(agent, 'logo.contentUrl')} alt="Online Sales Counselors" />
              </div>
              <div className="col-12 col-lg-8">
                <h4>{communityBody}</h4>
                <div className="row">
                  <div className="col-12">
                    <ContactModal>
                      <button name="contact-us" className="btn btn-block">Contact Now</button>
                    </ContactModal>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-6 floor-plan-btn">
            <div className="floor-plan-btn-inner">
              <h4>the<br /><span>{get(plan, 'name')}</span></h4>
              {
                get(home, 'floorplanPhotos', []).length > 0 &&
                <LightBox
                  items={get(home, 'floorplanPhotos', []).map(image => ({
                    url: get(image, 'contentUrl'),
                  }))}
                  button={(
                    <a className="btn">View This Floor Plan</a>
                  )}
                />
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

HomeAgent.propTypes = {
  agent: PropTypes.object.isRequired,
  home: PropTypes.object.isRequired,
  plan: PropTypes.object.isRequired,
};

export default withData(
  {
    home: true,
    agent: true,
    plan: true,
  },
  {
    require: {
      agent: true,
    },
  },
)(HomeAgent);



// WEBPACK FOOTER //
// ./src/pages/Homes/HomeAgent.js